import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transactions__item transaction card" }
const _hoisted_2 = { class: "transaction__icon transaction__icon--red" }
const _hoisted_3 = { class: "transaction__body" }
const _hoisted_4 = { class: "transaction__row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dd", { class: "transaction__title" }, "Replenishment", -1)
const _hoisted_6 = {
  class: "transaction__value transaction__value--big",
  "data-currency": "USDT"
}
const _hoisted_7 = { class: "transaction__row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("dd", { class: "transaction__subtitle" }, "Commission", -1)
const _hoisted_9 = {
  class: "transaction__value",
  "data-currency": "USDT"
}
const _hoisted_10 = { class: "transaction__row" }
const _hoisted_11 = { class: "transaction__subtitle" }
const _hoisted_12 = { class: "transaction__date" }

import moment from "moment";
import Icon from "@/components/Icon/Icon.vue";
import {computed} from "vue";
import WithdrawalEntity from "@/entities/WithdrawalEntity";
import {shorty} from "@/modules/helpers";

interface Props{
	withdrawal : WithdrawalEntity
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Withdrawal',
  props: {
    withdrawal: {}
  },
  setup(__props: any) {


let props = __props;

let date = computed<string>(() => {
	return moment(props.withdrawal.created_at).format('DD.MM.YYYY HH:mm');
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("i", _hoisted_2, [
      _createVNode(Icon, { name: "minus" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("dl", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("dt", _hoisted_6, "+" + _toDisplayString(_unref(props).withdrawal.amount.toFixed(2)), 1)
      ]),
      _createElementVNode("dl", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("dt", _hoisted_9, "-" + _toDisplayString(_unref(props).withdrawal.commission.toFixed(2)), 1)
      ]),
      _createElementVNode("dl", _hoisted_10, [
        _createElementVNode("dd", _hoisted_11, _toDisplayString(_unref(shorty)(_unref(props).withdrawal.wallet, 8)), 1),
        _createElementVNode("dt", _hoisted_12, _toDisplayString(_unref(date)), 1)
      ])
    ])
  ]))
}
}

})